var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.50039,
    cy: 7.50039,
    rx: 7.1,
    ry: 7.1,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77373 4.35609L4.48809 5.57991L9.82019 11.1813L11.1064 9.84571L9.8281 8.61419L5.77373 4.35609Z",
    fill: "#9B1E26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80635 4.35609L11.092 5.57991L5.75989 11.1813L4.4737 9.84571L5.75198 8.61419L9.80635 4.35609Z",
    fill: "#9B1E26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossicon);
export default __webpack_public_path__ + "static/media/cross icon.9770edd41567a32c96b0b66527dbe5c6.svg";
export { ForwardRef as ReactComponent };